import React from 'react';

import Button from '@material-ui/core/Button';
import CheckIcon from '@material-ui/icons/Check';
import CircularProgress from '@material-ui/core/CircularProgress';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import ConfirmDialog from '../ConfirmDialog';


const SaveButton = (props) => {
    const {
        state,
        coupleId,
        setCouple,
        setFormErrors
    } = props;

    const [savePending, setSavePending] = React.useState(false);
    const [saveComplete, setSaveComplete] = React.useState(false);

    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [snackbarMessage, setSnackbarMessage] = React.useState('');
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const [openWeddingDateDialog, setOpenWeddingDateDialog] = React.useState(false);
    const handleWeddingDateClose = action => () => {
        if (action == 'agree') {
            handleSubmit()
        }
        setOpenWeddingDateDialog(false);
    };

    const handleOnClick = () => {
        if (state.wedding_date_changed !== undefined && state.wedding_date_changed === true) {
            setOpenWeddingDateDialog(true);
        } else {
            handleSubmit();
        }
    }

    const handleSubmit = () => {
        const formData = {
            ...state,
            _token: window._token
        };
        new Promise((resolve, reject) => {
            resolve();
            let url = `/api/couples/${coupleId}/profile`;
            setSavePending(true);
            fetch(url, {
                method: 'PUT',
                body: JSON.stringify(formData),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    if (result.success) {
                        setCouple(result.wedding);
                        setSaveComplete(true);
                        setSavePending(false);
                        setFormErrors({});
                        setTimeout(() => {
                            setSaveComplete(false);
                        }, 5000);
                    } else {
                        setSavePending(false);
                        if (result.errors.bride_email || result.errors.groom_email) {
                            setFormErrors(result.errors);
                        } else {
                            setSnackbarMessage('There was an error with one or more of the form fields');
                            setOpenSnackbar(true);
                        }
                    }
                })
                .catch(reason => {
                    setSavePending(false);
                    alert('Please make sure all required fields have been entered.');
                })
        });
    };

    return (
        <React.Fragment>
            <Button
                variant="contained"
                color="primary"
                fullWidth={true}
                onClick={handleOnClick}
                disabled={savePending ? true : false}
                endIcon={savePending ? <CircularProgress size={20} /> : (saveComplete ? <CheckIcon /> : null)}
            >
                Save Changes
            </Button>
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                message={snackbarMessage}
                action={
                    <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackbar}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            />
            <ConfirmDialog
                title="Confirm Wedding Date and Time"
                text="Are you sure you wish to change the wedding date and time?"
                agreeText="Confirm"
                declineText="Cancel"
                handleClose={handleWeddingDateClose}
                open={openWeddingDateDialog}
            />
        </React.Fragment>
    )
}

export default SaveButton;
